import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useFormik } from "formik";
import * as Yup from "yup";
import InputField from "../../components/Controls/InputField/InputField";
import * as actions from "../../store/agencies/actions";
import { injectIntl } from "react-intl";
import './style.scss';
import DateFnsUtils from '@date-io/date-fns';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import { calendar } from '../../utils/images';
import moment from "moment";
import { Tooltip } from "@material-ui/core";
import RefreshIcon from '@material-ui/icons/Refresh';

const Filterform = ({ intl: { messages }, setSearchValues }) => {
  const dispatch = useDispatch();
  const payload = { page: 1, sort: "created_at,desc" };
  const [startDateState, setStartDateState] = useState(null);
  const [endDateState, setEndDateState] = useState(null);

  const initialValues = {
    search: "",
    startDate: null,
    endDate: null,
  };
  const Filterchema = Yup.object().shape({
    search: Yup.string(),
    startDate: Yup.date(),
    endDate: Yup.date(),
  });
  const formik = useFormik({
    initialValues,
    validationSchema: Filterchema,
    onSubmit: (values, { setStatus, setSubmitting }) => {},
  });
  
  const searchWithInput = (e, name) => {
    formik.setFieldValue(name, e.target.value);
    setSearchValues({search: e.target.value, startDate: formik.values.startDate, endDate: formik.values.endDate});
    dispatch(
      actions?.getAgencySamplesListRequest({
        ...payload,
        search: e.target.value,
      })
    );
  };

  const searchWithDate = () => {
    formik.setFieldValue('startDate', startDateState);
    formik.setFieldValue('endDate', endDateState);
    setSearchValues({ search: formik.values.search, startDate: startDateState, endDate: endDateState});
    dispatch(
      actions?.getAgencySamplesListRequest({
        ...payload,
        ...formik.values,
        startDate: startDateState,
        endDate: endDateState,
      })
    );
}; 

useEffect(() => {
  if (startDateState || endDateState) {
    searchWithDate()
  }
// eslint-disable-next-line react-hooks/exhaustive-deps
}, [startDateState, endDateState])

  return (
    <div>
      <form className="form fv-plugins-bootstrap fv-plugins-framework payments_filter">
        <div className="row" style={{ flexWrap: 'nowrap' }}>
          <div className="col-md-4">
            <InputField
              size="small"
              className={'bg-white phone_number'}
              label={messages.payments.search}
              id="search"
              name="search"
              value={formik.values.search}
              changeHandler={formik.handleChange}
              error={formik.errors.search}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                  searchWithInput(e, "search");
                }
              }}
            />
          </div>
          <div className="col-md-6 selection">
              <div className='dates-container'>
                <span className="date-label">{messages.payments.date}</span>
                  <div className="date-input-container">
                      <MuiPickersUtilsProvider utils={DateFnsUtils}>
                          <KeyboardDatePicker
                              clearable
                              inputProps={{ 'placeholder': `${messages.shared.from}` }}
                              value={startDateState}
                              onChange={date => date ? setStartDateState(moment(date).format('YYYY-MM-DD')) : setStartDateState(null)}
                              format="yyyy-MM-dd"
                              keyboardIcon={<img src={calendar} alt="calendar" width="15px" height="15px"/>}
                          />
                      </MuiPickersUtilsProvider>
                  </div>
                  <div className="date-input-container">
                      <MuiPickersUtilsProvider utils={DateFnsUtils}>
                          <KeyboardDatePicker
                              clearable
                              inputProps={{ 'placeholder': `${messages.shared.to}` }}
                              value={endDateState}
                              onChange={date => date ? setEndDateState(moment(date).format('YYYY-MM-DD')) : setEndDateState(null)}
                              format="yyyy-MM-dd"
                              keyboardIcon={<img src={calendar} alt="calendar" width="15px" height="15px"/>}
                          />
                      </MuiPickersUtilsProvider>
                  </div>
                  <div className='icon-container'>
                      <Tooltip title={`${messages.appointments.refresh}`} placement="bottom" >
                          <div><RefreshIcon title='clear' onClick={() => {
                              setStartDateState(null);
                              setEndDateState(null);
                              formik.setFieldValue('search', "");
                              formik.setFieldValue('status', 0);
                              dispatch(
                                actions?.getAgencySamplesListRequest({
                                  ...payload,
                                  initialValues,
                                })
                              );
                          }} /></div>
                      </Tooltip>
                  </div>
              </div>
            </div>
        </div>
      </form>
    </div>
  );
};

export default injectIntl(Filterform);
